/**
 * Page-specific meta descriptions for pages whose content is not usable as a
 * description source.
 *
 * Why this file exists: `Article.body` is NOT the article text at build time.
 * The MDX transformer replaces it with the *compiled MDX component source*, so
 * it reads like
 *
 *   var _excluded = ["components"]; function _extends() { ...
 *   ... mdx("h2", null, "Angaben gemäß § 5 TMG"), mdx("p", null, ...
 *
 * Stripping HTML tags from that yields JavaScript, and the theme's derived
 * `excerpt` for those articles came back as that same code — which is how
 * /impressum/ once shipped Babel runtime helpers as its meta description.
 *
 * So: no text-scraping heuristics. Pages that need a description and cannot get
 * one from the CMS (the Article content type has no description field) get one
 * written here, next to the copy it describes.
 *
 * This is the English site. Note that its /impressum/ page legitimately carries
 * the German legal notice (required by § 5 TMG), so the English description
 * says what the page is rather than restating the German text.
 *
 * Keep every entry factual and derived from the page itself — nothing invented.
 * Only list pages that actually exist; the build check asserts each key
 * resolves to a real page and is actually applied.
 */
const DESCRIPTIONS = {
  // 146 chars - keep under 155 so nothing is lost to truncation.
  '/impressum/':
    'Legal notice (Impressum) for Primula Medical Travel: provider identification under § 5 TMG, contact details, VAT ID and editorial responsibility.',
}

/** Look up an override by slug, tolerating a missing or trailing slash. */
export const descriptionForSlug = slug => {
  if (!slug) return ''
  const normalised = `/${String(slug).replace(/^\/+|\/+$/g, '')}/`
  return DESCRIPTIONS[normalised] || ''
}

export default DESCRIPTIONS
